import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  necessary: {
    id: 'cookie-banner.checkboxes.label.necessary',
    defaultMessage: 'Necessary',
  },
  marketingAndAnalytics: {
    id: 'cookie-banner.checkboxes.label.marketing-analytics',
    defaultMessage: 'Analytics',
  },
  advertising: {
    id: 'cookie-banner.checkboxes.label.marketing',
    defaultMessage: 'Marketing',
  },
});
